import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import React, { useEffect, useMemo } from 'react';
import { BasePageContext } from "../../../contexts/basepage-context";
import { useCustomRegionDeleteMutation, useGetCustomRegionListLazyQuery, } from "../../../services/chart-customization/chart-customization-service";
import { DependencyListObjectType } from "../../../services/generated/graphql-types";
import { useListDependentsMutation } from "../../../services/listdependents/listdependents-service";
import { getParsedDependents } from "../../../utils/dependents";
import { Geomap } from './geomap';
export const GeoMapContainer = ({ currentOrgId, }) => {
    const { metricsService } = BasePageContext();
    const { getCustomRegionList, data: customRegionList, error: customRegionListError, loading: customRegionListLoading, } = useGetCustomRegionListLazyQuery(currentOrgId);
    useEffect(() => {
        getCustomRegionList();
    }, []);
    const { error: customRegionDeleteError, loading: customRegionDeleteLoading, deleteCustomRegion, } = useCustomRegionDeleteMutation();
    const { data: dependentsData, error: listDependentsError, loading: listDependentsLoading, useListDependents, } = useListDependentsMutation();
    const visibleDependents = useMemo(() => getParsedDependents(dependentsData, DependencyListObjectType.LogicalTable), [dependentsData]);
    return (React.createElement(Vertical, null,
        React.createElement(Geomap, { collectEvent: metricsService.collectEvent, data: customRegionList, loading: customRegionListLoading ||
                customRegionDeleteLoading ||
                listDependentsLoading, dependentsData: visibleDependents, fetchDependents: useListDependents, deleteCustomRegion: deleteCustomRegion, getCustomRegionList: getCustomRegionList, currentOrgId: currentOrgId })));
};
//# sourceMappingURL=geomap.container.js.map